import React from 'react';

import { DockMenuProps } from './index.types';
import { DockMenuView } from './index.view';

export default function DockMenu(props: DockMenuProps) {
  return <DockMenuView {...props} />;
}
